import React, {useEffect, useState} from 'react';
import { Card, Statistic, Avatar, Row, Col } from 'antd';
import { CarOutlined } from '@ant-design/icons';
import Api from "../../../../services/Api";

const HomeAracGecisComponent = () => {
    const [data, setData] = useState(null);
    const getData = () => {
        Api.get("/api/FotoKapan/GetBugunKazanclar").then(res => {
            setData(res.data);
        }).catch(err => {
            console.error("Veri alınırken hata oluştu:", err);
        })
    }

    useEffect(() => {
        getData()
    }, []);


    return (
        <Card title={"Araç Geçişleri"} bordered={false}>
            <Row align="middle" justify="center" gutter={16}>
                {/* Avatar üstte (mobilde tam genişlik), yan yana gösterim için sm breakpoint */}
                <Col xs={24} sm={24} style={{ textAlign: 'center' }}>
                    <Avatar size={56} style={{ backgroundColor: '#722ed1', color: '#fff' }} icon={<CarOutlined style={{ color: '#fff', fontSize: 24 }} />} />
                </Col>

                {/* Sayı kısmı: mobilde alt satırda, masaüstünde sağda */}
                <Col xs={24} sm={24} style={{ textAlign: 'center' }}>
                    <Statistic
                        title="Bugün"
                        value={data?.istasyon1?.shots/2 ?? 0}
                        formatter={v => String(v)}
                        valueStyle={{ fontSize: 32, fontWeight: 600 }}
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default HomeAracGecisComponent;
